module.exports = __webpack_public_path__ + "modal-bg.92e5ebc9071e714cc0d2.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/img/modal-bg.jpg
// module id = ../../../../../src/assets/img/modal-bg.jpg
// module chunks = styles assessment.module